import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'duration' })
export class DurationPipe implements PipeTransform {
  readonly SECS_IN_HOUR = 3600;
  readonly SECS_IN_MIN = 60;

  transform(millis: number | null): string | null {
    // safety guard for undefined when template is loading
    if (millis === null) {
      return null;
    }

    const seconds = millis / 1000;

    const hours = Math.floor(seconds / this.SECS_IN_HOUR);
    const hoursFormatted =
      hours.toString().length > 1 ? hours : `0${hours}`.slice(-2);

    const mins = Math.floor((seconds % this.SECS_IN_HOUR) / this.SECS_IN_MIN);
    const minsFormatted = `0${mins}`.slice(-2);

    const secs = (seconds % this.SECS_IN_HOUR) % this.SECS_IN_MIN;
    const secsFormatted = `0${secs}`.slice(-2);

    return `${hoursFormatted} : ${minsFormatted} : ${secsFormatted}`;
  }
}
